import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { libraryShape, listShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import ListCard from '@bibliocommons/list-card';

import './ListsRow.scss';

export default class ListsRow extends React.PureComponent {
  renderItem(list) {
    const { stacked, library, users } = this.props;
    const className = cn('list-item', stacked ? 'col-sm-12' : 'col-sm-3');
    const creator = users.get(list.getIn(['owner', 'id']).toString());

    return (
      <li key={list.get('id')} className={className}>
        <ListCard
          creator={creator}
          library={library}
          list={list}
          titleTag="div"
          horizontal={stacked}
          smallHeading
          smallCreatorLink
        />
      </li>
    );
  }

  render() {
    const { lists, className, stacked } = this.props;
    const classNames = cn('cp-lists-row', 'row', className, { stacked });

    return <ul className={classNames}>{lists.map(list => this.renderItem(list))}</ul>;
  }
}

ListsRow.propTypes = {
  className: PropTypes.string,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  library: libraryShape,
  lists: ImmutablePropTypes.listOf(listShape),
  stacked: PropTypes.bool
};
